import React from 'react';

const BookList = ({
  books,
  handleBookImport,
  booksBeingImported,
  booksImported
}) => {
  return (
    <div className="gb-booklist">
      <table className="wp-list-table widefat fixed striped">
        <thead>
          <tr>
            <td className="table-image">Image</td>
            <td className="table-title">Title</td>
            <td className="table-description">Description</td>
            <td className="table-authors">Authors</td>
            <td />
          </tr>
        </thead>
        <tbody>
          {books.map(item => {
            return (
              <tr key={item.id}>
                <td className="item-image">
                  <img src={item.image} alt="" />
                </td>
                <td className="item-title">
                  <div className="item-title-maintitle">{item.title}</div>
                  <div className="item-title-subtitle">{item.subtitle}</div>
                  <div className="item-title-previewlink">
                    <a href={item.previewLink} target="_blank">
                      Preview <span className="dashicons dashicons-external" />
                    </a>
                  </div>
                </td>
                <td className="item-description">{item.description}</td>
                <td className="item-author">
                  {item.authors.map(author => (
                    <div key={author}>{author}</div>
                  ))}
                </td>
                <td className="item-options">
                  {booksImported.includes(item.id) ? (
                    'Imported'
                  ) : (
                    <button
                      className="button"
                      onClick={() => handleBookImport(item)}
                      disabled={booksBeingImported.includes(item.id)}
                    >
                      {booksBeingImported.includes(item.id)
                        ? 'Importing..'
                        : 'Import'}
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {!books.length && <p>No results to show.</p>}
    </div>
  );
};

export default BookList;



// WEBPACK FOOTER //
// ./src/components/bookList.jsx